"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computeFontSize = (globalFontSize) => (fontSize) => {
    if (fontSize.type === 'custom') {
        return fontSize.value;
    }
    if (fontSize.type === 'global') {
        return globalFontSize;
    }
    return undefined;
};
exports.default = computeFontSize;
